import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import * as validators from '../../../util/validators';

// Shared UI components
import { Form, FieldTextInput, FieldSelect, PrimaryButton } from '../../index';
import IconCard from '../../SavedCardDetails/IconCard/IconCard';

import css from './ContactUsForm.module.css';
import { useIntl } from 'react-intl';
import { sendContactUs } from '../../../util/api';

const ContactUsForm = () => {
    const intl = useIntl();
    const [submitError, setSubmitError] = useState(null);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const required = validators.required(
        intl.formatMessage({ id: 'ContactUsForm.validation.required' })
    );
    const emailValid = validators.emailFormatValid(
        intl.formatMessage({ id: 'ContactUsForm.validation.emailInvalid' })
    );

    return (
        <div id="contact-us-form-container">
            {/* Form */}
            <FinalForm
                onSubmit={async (values, form) => {
                    setSubmitError(null);
                    setSubmitSuccess(false);
                    try {
                        await sendContactUs(values);
                        setSubmitSuccess(true);
                        form.restart();
                    } catch (e) {
                        const fallback = intl.formatMessage({ id: 'ContactUsForm.submitError' });
                        setSubmitError(e?.message || fallback);
                    }
                }}
                onSubmitFailed={() => {
                    setSubmitSuccess(false);
                }}
                render={({ handleSubmit, pristine, invalid, submitting }) => {
                    const submitDisabled = invalid || pristine || submitting;
                    return (
                        <Form onSubmit={handleSubmit}>
                            <FieldTextInput
                                className={css.fieldRow}
                                name="fullName"
                                id="fullName"
                                label={intl.formatMessage({
                                    id: 'ContactUsForm.fullName',
                                  })}
                                placeholder={intl.formatMessage({
                                    id: 'ContactUsForm.enterNamePlaceholder',
                                })}
                                validate={required}
                            />

                            <FieldTextInput
                                className={css.fieldRow}
                                name="email"
                                id="email"
                                type="email"
                                label={intl.formatMessage({
                                    id: 'ContactUsForm.email',
                                  })}
                                placeholder={intl.formatMessage({
                                    id: 'ContactUsForm.enterEmailPlaceholder',
                                })}
                                validate={validators.composeValidators(required, emailValid)}
                            />

                            <FieldSelect
                                className={css.fieldRow}
                                 name="inquiryType"
                                  id="inquiryType" 
                                  label={intl.formatMessage({
                                    id: 'ContactUsForm.inquiryType',
                                  })}
                                  validate={required}
                                  >
                                <option value="" disabled>
                                    {intl.formatMessage({ id: 'ContactUsForm.inquiryTypePlaceholder' })}
                                </option>
                                <option value="technical">
                                    {intl.formatMessage({ id: 'ContactUsForm.inquiryType.technical' })}
                                </option>
                                <option value="payment">
                                    {intl.formatMessage({ id: 'ContactUsForm.inquiryType.payment' })}
                                </option>
                                <option value="other">
                                    {intl.formatMessage({ id: 'ContactUsForm.inquiryType.other' })}
                                </option>
                            </FieldSelect>

                            <FieldTextInput
                                className={css.fieldRow}
                                name="message"
                                id="message"
                                type="textarea"
                                label={intl.formatMessage({
                                    id: 'ContactUsForm.weHelp',
                                  })}
                                placeholder={intl.formatMessage({
                                    id: 'ContactUsForm.enterMessagePlaceholder',
                                })}
                                validate={required}
                            />

                            <PrimaryButton className={css.submitBtn} type="submit" disabled={submitDisabled} inProgress={submitting}>
                                {intl.formatMessage({
                                    id: 'ContactUsForm.sendMessage',
                                  })}
                                <IconCard type="rightarrow" />
                            </PrimaryButton>

                            {submitSuccess ? (
                                <p className={css.submitSuccess}>
                                    {intl.formatMessage({ id: 'ContactUsForm.submitSuccess' })}
                                </p>
                            ) : null}
                            {submitError ? (
                                <p className={css.submitError}>{submitError}</p>
                            ) : null}

                            <p className={css.replyTime}>
                                {intl.formatMessage({
                                    id: 'ContactUsForm.replyTime',
                                  })}
                            </p>
                        </Form>
                    );
                }}
            />
        </div>
    );
};

export default ContactUsForm;
